var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5566_96694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4775 12.7553L10.5918 12.7263C12.6633 12.3492 14.449 11.711 15.9061 10.8408L15.549 7.30203C15.0061 7.41806 14.4204 7.47607 13.8204 7.47607C12.6918 7.47607 11.8775 7.27302 11.849 7.25852L11.6347 7.20051L11.7633 7.02647C11.8204 6.95395 13.1204 5.24257 15.2347 4.38687L15.1775 3.83575H14.4918L16.6918 0.5L16.6061 4.00979C17.0918 3.92277 17.6204 3.87926 18.149 3.87926C19.2775 3.87926 20.0918 4.08231 20.1204 4.09681L20.3347 4.15482L20.2061 4.32886C20.149 4.40138 18.7775 6.21429 16.549 7.02647L16.4633 10.4927C18.6347 8.99891 19.1633 7.41806 19.1775 7.40355L19.449 7.46157L19.0204 11.421L10.4775 20.5V12.7553Z",
    fill: "url(#paint0_linear_5566_96694)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4204 6.91044C18.6918 6.11276 20.1061 4.22734 20.1061 4.22734C20.1061 4.22734 18.4061 3.79224 16.4918 4.18383L16.5633 0.993111L14.7775 3.69072H15.3204L15.4061 4.4884C13.2347 5.31508 11.8918 7.11349 11.8918 7.11349C11.8918 7.11349 13.6775 7.57759 15.6775 7.11349L16.0633 10.9133C14.7775 11.6965 13.0204 12.4217 10.6204 12.8713V20.1084L18.8918 11.3339L19.3204 7.43256C19.3204 7.43256 18.7633 9.17295 16.3347 10.7538L16.4204 6.91044Z",
    fill: "url(#paint1_linear_5566_96694)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3 11.4065L0.871428 7.44706L1.15714 7.38905C1.15714 7.40355 1.7 8.98441 3.87143 10.4782L3.78571 7.01197C1.54286 6.18528 0.185714 4.38687 0.128571 4.31436L0 4.14032L0.214286 4.08231C0.242857 4.0678 1.04286 3.86476 2.18571 3.86476C2.71429 3.86476 3.22857 3.90827 3.72857 3.99529L3.62857 0.5L5.82857 3.83575H5.14286L5.08571 4.38687C7.2 5.24257 8.5 6.95395 8.55714 7.02647L8.68571 7.20051L8.47143 7.25852C8.44286 7.27302 7.64286 7.47607 6.5 7.47607C5.9 7.47607 5.32857 7.41806 4.77143 7.30203L4.41429 10.8408C5.85714 11.711 7.65714 12.3492 9.72857 12.7263L9.84286 12.7553V20.4855L1.3 11.4065Z",
    fill: "#CFB38D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91429 6.91044C1.64286 6.11276 0.242857 4.22734 0.242857 4.22734C0.242857 4.22734 1.94286 3.79224 3.85714 4.18383L3.78571 0.993111L5.55714 3.69072H5.01428L4.92857 4.4884C7.1 5.31508 8.44286 7.11349 8.44286 7.11349C8.44286 7.11349 6.65714 7.57759 4.65714 7.11349L4.27143 10.9133C5.55714 11.6965 7.31429 12.4217 9.71428 12.8713V20.1084L1.44286 11.3484L1.01429 7.44706C1.01429 7.44706 1.57143 9.18746 4 10.7683L3.91429 6.91044Z",
    fill: "url(#paint2_linear_5566_96694)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5566_96694",
    x1: 18.8904,
    y1: 7.1686,
    x2: 9.22076,
    y2: 13.0582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F5C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#332A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F5C40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5566_96694",
    x1: 10.6119,
    y1: 13.0139,
    x2: 18.0718,
    y2: 7.03289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3F2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F5C40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5566_96694",
    x1: 1.80703,
    y1: 8.56136,
    x2: 15.5655,
    y2: 13.9345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5566_96694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.af6fb9054b8206d245b1a91cb39fccbb.svg";
export { ForwardRef as ReactComponent };